import {
  SET_MARKUP_DEDUCT_PERCENTAGE,
  DATA_UPDATED,
  SET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE,
  SET_GOLD_SILVER_PRICE,
  SET_UPDATED_LIVE_QUOTES_PRICE,
} from 'redux/constants/MarkupDeductPercentage';

const initState = {
  markupDeductPercentage: undefined,
  currentGoldSilverPrice: undefined,
  markupDeductPercentageForm: undefined,
  updatedLiveQuotesPrice: undefined,
  updatedSwitch: false,
};

const markupDeductPercentages = (state = initState, action) => {
  switch (action.type) {
    case SET_MARKUP_DEDUCT_PERCENTAGE:
      let markupDeductPercentageForm = [
        {
          name: ['Gold', 'WeBuy'],
          value: parseFloat(action.markupDeductPercentage.Gold.WeBuy),
        },
        {
          name: ['Gold', 'WeSell'],
          value: parseFloat(action.markupDeductPercentage.Gold.WeSell),
        },
        {
          name: ['Silver', 'WeBuy'],
          value: parseFloat(action.markupDeductPercentage.Silver.WeBuy),
        },
        {
          name: ['Silver', 'WeSell'],
          value: parseFloat(action.markupDeductPercentage.Silver.WeSell),
        },
      ];

      return {
        ...state,
        markupDeductPercentage: action.markupDeductPercentage,
        markupDeductPercentageForm,
      };
    case DATA_UPDATED:
      return {
        ...state,
        updatedSwitch: state.updatedSwitch ? false : true,
      };
    case SET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE:
      return {
        ...state,
        liveQuotesPrice: action.liveQuotesPrice,
      };
    case SET_GOLD_SILVER_PRICE:
      return {
        ...state,
        currentGoldSilverPrice: action.currentGoldSilverPrice,
      };
    case SET_UPDATED_LIVE_QUOTES_PRICE:
      return {
        ...state,
        updatedLiveQuotesPrice: action.updatedLiveQuotesPrice,
      };
    default:
      return state;
  }
};

export default markupDeductPercentages;
